/**
 * Makes the minimum number of necessary requests for setting the locales.
 */

define('lib/set-language',['require','exports','module','tealium-utils','i18next','api-access','lodash','moment'],function (require, exports, module) {
    var tealiumUtils = require('tealium-utils');
    var i18n = require('i18next');
    var apiAccess = require('api-access');
    var _ = require('lodash');
    var moment = require('moment');

    var setLanguage = function () {
        var languagePromise = $.Deferred();

        apiAccess.user.settings().then(function (settings) {
            var supportedLocales = ['de', 'en', 'en-AU', 'en-CA', 'en-GB', 'es', 'fr', 'fr-CA', 'it', 'pt', 'zh'];
            var locale;
            if (settings.locale) {
                tealiumUtils.updateTealiumLocaleData(settings.locale);
                locale = settings.locale.replace('_', '-'); // i18next and moment expect dashes
                moment.locale(locale);
            }

            /*
             * Continue looping if the locale fails to match any supported locales.
             * Each iteration will set the locale to be less specific until a match is found,
             * otherwise the locale falls back to 'en'.
             * Ex: uz-Cyrl-UZ -> uz-Cyrl -> uz -> en
             */
            var dashIndex;
            while (!_.contains(supportedLocales, locale)) {
                dashIndex = locale.lastIndexOf('-');
                if (dashIndex > -1) {
                    locale = locale.substring(0, dashIndex);
                } else {
                    locale = 'en';
                }
            }

            i18n.setLng(locale, function () {
                languagePromise.resolve();
            });
        });

        return languagePromise.promise();
    };

    module.exports = setLanguage;
});

